// src/utils/currencyOptions.js
// Full currency options array for reuse across the app

export const currencyOptions = [
  { value: "USD", label: "USD", symbol: "$" },
  { value: "AED", label: "AED", symbol: "د.إ" },
  { value: "AFN", label: "AFN", symbol: "؋" },
  { value: "ALL", label: "ALL", symbol: "L" },
  { value: "AMD", label: "AMD", symbol: "֏" },
  { value: "ANG", label: "ANG", symbol: "ƒ" },
  { value: "AOA", label: "AOA", symbol: "Kz" },
  { value: "ARS", label: "ARS", symbol: "$" },
  { value: "AUD", label: "AUD", symbol: "A$" },
  { value: "AWG", label: "AWG", symbol: "ƒ" },
  { value: "AZN", label: "AZN", symbol: "₼" },
  { value: "BAM", label: "BAM", symbol: "KM" },
  { value: "BBD", label: "BBD", symbol: "Bds$" },
  { value: "BDT", label: "BDT", symbol: "৳" },
  { value: "BGN", label: "BGN", symbol: "лв" },
  { value: "BHD", label: "BHD", symbol: ".د.ب" },
  { value: "BIF", label: "BIF", symbol: "FBu" },
  { value: "BMD", label: "BMD", symbol: "$" },
  { value: "BND", label: "BND", symbol: "B$" },
  { value: "BOB", label: "BOB", symbol: "Bs." },
  { value: "BRL", label: "BRL", symbol: "R$" },
  { value: "BSD", label: "BSD", symbol: "B$" },
  { value: "BTN", label: "BTN", symbol: "Nu." },
  { value: "BWP", label: "BWP", symbol: "P" },
  { value: "BYN", label: "BYN", symbol: "Br" },
  { value: "BZD", label: "BZD", symbol: "BZ$" },
  { value: "CAD", label: "CAD", symbol: "C$" },
  { value: "CDF", label: "CDF", symbol: "FC" },
  { value: "CHF", label: "CHF", symbol: "CHF" },
  { value: "CLP", label: "CLP", symbol: "$" },
  { value: "CNY", label: "CNY", symbol: "¥" },
  { value: "COP", label: "COP", symbol: "$" },
  { value: "CRC", label: "CRC", symbol: "₡" },
  { value: "CUP", label: "CUP", symbol: "₱" },
  { value: "CVE", label: "CVE", symbol: "$" },
  { value: "CZK", label: "CZK", symbol: "Kč" },
  { value: "DJF", label: "DJF", symbol: "Fdj" },
  { value: "DKK", label: "DKK", symbol: "kr" },
  { value: "DOP", label: "DOP", symbol: "RD$" },
  { value: "DZD", label: "DZD", symbol: "دج" },
  { value: "EGP", label: "EGP", symbol: "£" },
  { value: "ERN", label: "ERN", symbol: "Nfk" },
  { value: "ETB", label: "ETB", symbol: "Br" },
  { value: "EUR", label: "EUR", symbol: "€" },
  { value: "FJD", label: "FJD", symbol: "FJ$" },
  { value: "FKP", label: "FKP", symbol: "£" },
  { value: "FOK", label: "FOK", symbol: "kr" },
  { value: "GBP", label: "GBP", symbol: "£" },
  { value: "GEL", label: "GEL", symbol: "₾" },
  { value: "GGP", label: "GGP", symbol: "£" },
  { value: "GHS", label: "GHS", symbol: "₵" },
  { value: "GIP", label: "GIP", symbol: "£" },
  { value: "GMD", label: "GMD", symbol: "D" },
  { value: "GNF", label: "GNF", symbol: "FG" },
  { value: "GTQ", label: "GTQ", symbol: "Q" },
  { value: "GYD", label: "GYD", symbol: "GY$" },
  { value: "HKD", label: "HKD", symbol: "HK$" },
  { value: "HNL", label: "HNL", symbol: "L" },
  { value: "HRK", label: "HRK", symbol: "kn" },
  { value: "HTG", label: "HTG", symbol: "G" },
  { value: "HUF", label: "HUF", symbol: "Ft" },
  { value: "IDR", label: "IDR", symbol: "Rp" },
  { value: "ILS", label: "ILS", symbol: "₪" },
  { value: "IMP", label: "IMP", symbol: "£" },
  { value: "INR", label: "INR", symbol: "₹" },
  { value: "IQD", label: "IQD", symbol: "ع.د" },
  { value: "IRR", label: "IRR", symbol: "﷼" },
  { value: "ISK", label: "ISK", symbol: "kr" },
  { value: "JEP", label: "JEP", symbol: "£" },
  { value: "JMD", label: "JMD", symbol: "J$" },
  { value: "JOD", label: "JOD", symbol: "د.ا" },
  { value: "JPY", label: "JPY", symbol: "¥" },
  { value: "KES", label: "KES", symbol: "KSh" },
  { value: "KGS", label: "KGS", symbol: "с" },
  { value: "KHR", label: "KHR", symbol: "៛" },
  { value: "KID", label: "KID", symbol: "A$" },
  { value: "KMF", label: "KMF", symbol: "CF" },
  { value: "KRW", label: "KRW", symbol: "₩" },
  { value: "KWD", label: "KWD", symbol: "د.ك" },
  { value: "KYD", label: "KYD", symbol: "CI$" },
  { value: "KZT", label: "KZT", symbol: "₸" },
  { value: "LAK", label: "LAK", symbol: "₭" },
  { value: "LBP", label: "LBP", symbol: "ل.ل" },
  { value: "LKR", label: "LKR", symbol: "Rs" },
  { value: "LRD", label: "LRD", symbol: "L$" },
  { value: "LSL", label: "LSL", symbol: "L" },
  { value: "LYD", label: "LYD", symbol: "ل.د" },
  { value: "MAD", label: "MAD", symbol: "DH" },
  { value: "MDL", label: "MDL", symbol: "L" },
  { value: "MGA", label: "MGA", symbol: "Ar" },
  { value: "MKD", label: "MKD", symbol: "ден" },
  { value: "MMK", label: "MMK", symbol: "K" },
  { value: "MNT", label: "MNT", symbol: "₮" },
  { value: "MOP", label: "MOP", symbol: "MOP$" },
  { value: "MRU", label: "MRU", symbol: "UM" },
  { value: "MUR", label: "MUR", symbol: "₨" },
  { value: "MVR", label: "MVR", symbol: "Rf" },
  { value: "MWK", label: "MWK", symbol: "MK" },
  { value: "MXN", label: "MXN", symbol: "Mex$" },
  { value: "MYR", label: "MYR", symbol: "RM" },
  { value: "MZN", label: "MZN", symbol: "MT" },
  { value: "NAD", label: "NAD", symbol: "N$" },
  { value: "NGN", label: "NGN", symbol: "₦" },
  { value: "NIO", label: "NIO", symbol: "C$" },
  { value: "NOK", label: "NOK", symbol: "kr" },
  { value: "NPR", label: "NPR", symbol: "₨" },
  { value: "NZD", label: "NZD", symbol: "NZ$" },
  { value: "OMR", label: "OMR", symbol: "ر.ع." },
  { value: "PAB", label: "PAB", symbol: "B/." },
  { value: "PEN", label: "PEN", symbol: "S/." },
  { value: "PGK", label: "PGK", symbol: "K" },
  { value: "PHP", label: "PHP", symbol: "₱" },
  { value: "PKR", label: "PKR", symbol: "₨" },
  { value: "PLN", label: "PLN", symbol: "zł" },
  { value: "PYG", label: "PYG", symbol: "₲" },
  { value: "QAR", label: "QAR", symbol: "ر.ق" },
  { value: "RON", label: "RON", symbol: "lei" },
  { value: "RSD", label: "RSD", symbol: "дин." },
  { value: "RUB", label: "RUB", symbol: "₽" },
  { value: "RWF", label: "RWF", symbol: "FRw" },
  { value: "SAR", label: "SAR", symbol: "﷼" },
  { value: "SBD", label: "SBD", symbol: "SI$" },
  { value: "SCR", label: "SCR", symbol: "₨" },
  { value: "SDG", label: "SDG", symbol: "ج.س" },
  { value: "SEK", label: "SEK", symbol: "kr" },
  { value: "SGD", label: "SGD", symbol: "S$" },
  { value: "SHP", label: "SHP", symbol: "£" },
  { value: "SLE", label: "SLE", symbol: "Le" },
  { value: "SLL", label: "SLL", symbol: "Le" },
  { value: "SOS", label: "SOS", symbol: "Sh.So." },
  { value: "SRD", label: "SRD", symbol: "SR$" },
  { value: "SSP", label: "SSP", symbol: "£" },
  { value: "STN", label: "STN", symbol: "Db" },
  { value: "SYP", label: "SYP", symbol: "£" },
  { value: "SZL", label: "SZL", symbol: "L" },
  { value: "THB", label: "THB", symbol: "฿" },
  { value: "TJS", label: "TJS", symbol: "SM" },
  { value: "TMT", label: "TMT", symbol: "m" },
  { value: "TND", label: "TND", symbol: "د.ت" },
  { value: "TOP", label: "TOP", symbol: "T$" },
  { value: "TRY", label: "TRY", symbol: "₺" },
  { value: "TTD", label: "TTD", symbol: "TT$" },
  { value: "TVD", label: "TVD", symbol: "T$" },
  { value: "TWD", label: "TWD", symbol: "NT$" },
  { value: "TZS", label: "TZS", symbol: "TSh" },
  { value: "UAH", label: "UAH", symbol: "₴" },
  { value: "UGX", label: "UGX", symbol: "USh" },
  { value: "UYU", label: "UYU", symbol: "$U" },
  { value: "UZS", label: "UZS", symbol: "so'm" },
  { value: "VES", label: "VES", symbol: "Bs.S" },
  { value: "VND", label: "VND", symbol: "₫" },
  { value: "VUV", label: "VUV", symbol: "VT" },
  { value: "WST", label: "WST", symbol: "WS$" },
  { value: "XAF", label: "XAF", symbol: "FCFA" },
  { value: "XCD", label: "XCD", symbol: "EC$" },
  { value: "XCG", label: "XCG", symbol: "¤" }, // Not standard, kept generic
  { value: "XDR", label: "XDR", symbol: "SDR" },
  { value: "XOF", label: "XOF", symbol: "CFA" },
  { value: "XPF", label: "XPF", symbol: "₣" },
  { value: "YER", label: "YER", symbol: "﷼" },
  { value: "ZAR", label: "ZAR", symbol: "R" },
  { value: "ZMW", label: "ZMW", symbol: "ZK" },
  { value: "ZWL", label: "ZWL", symbol: "Z$" },
];
